import Vue from 'vue'
import VueRouter from 'vue-router'
import Grenstall from '../views/Grenstall.vue'

Vue.use(VueRouter)

const routes = [

  {
    // '/branch_config' for production
    // '/' for develop
    path: '/',
    name: 'Grenstall',
    component: Grenstall
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: "history",
  routes
})

export default router
